export default __webpack_public_path__ + "static/media/esports-active-m.2edc3a27.svg";